<template>
  <base-layout>
  <template v-slot:header>
    <app-header/>
  </template>

<template v-slot:banner>
<HomeBanner/>
</template>
  <template v-slot:default>
   <ProductList/>
  </template>

  <template v-slot:footer>
   <app-footer/>
  </template>
</base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import ProductList from '@/components/ProductList'
import HomeBanner from '@/components/HomeBanner'
import BaseLayout from '@/layout/BaseLayout'

export default {
  components: {
    BaseLayout,
    AppHeader,
    ProductList,
    HomeBanner,
    AppFooter
  }
}
</script>
<style>
 .clickable {
   cursor:pointer
 }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue